(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enetura-track"]) return;
  try {
    
(() => {
  const storageKey = 'enetura-recent-tracking';
  function initialise(root) {
    if (root.dataset.trackingReady) return;
    root.dataset.trackingReady = 'true';
    const form = root.querySelector('.et-form');
    const input = root.querySelector('.et-number');
    const status = root.querySelector('.et-status');
    const recent = root.querySelector('.et-recent');
    const chips = root.querySelector('.et-chips');
    const valid = value => /^[A-Z0-9-]{6,80}$/.test(value);
    const parse = value => [...new Set(value.toUpperCase().split(',').map(number => number.replace(/\s/g, '')).filter(Boolean))];
    function readRecent() {
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(stored) ? stored.filter(value => typeof value === 'string' && valid(value)).slice(0, 5) : [];
      } catch { return []; }
    }
    function saveRecent(values) {
      try { localStorage.setItem(storageKey, JSON.stringify(values)); } catch {}
    }
    function paint() {
      const values = readRecent();
      chips.replaceChildren();
      recent.hidden = !values.length;
      values.forEach(value => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'et-chip';
        button.textContent = value;
        button.addEventListener('click', () => {
          input.value = value;
          input.removeAttribute('aria-invalid');
          status.textContent = '';
          input.focus();
        });
        chips.append(button);
      });
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      const values = parse(input.value);
      const error = !values.length ? root.dataset.errorEmpty : values.length > 10 || !values.every(valid) ? root.dataset.errorInvalid : '';
      if (error) {
        input.setAttribute('aria-invalid', 'true');
        status.dataset.error = 'true';
        status.textContent = error;
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      input.value = values.join(', ');
      status.dataset.error = 'false';
      status.textContent = root.dataset.opening;
      saveRecent([...new Set([...values, ...readRecent()])].slice(0, 5));
      paint();
      window.open('https://t.17track.net/en#nums=' + values.map(encodeURIComponent).join(','), '_blank', 'noopener,noreferrer');
    });
    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      status.textContent = '';
    });
    root.querySelector('.et-clear').addEventListener('click', () => {
      saveRecent([]);
      paint();
    });
    const parameters = new URLSearchParams(window.location.search);
    const prefill = parameters.get('number') || parameters.get('tracking') || parameters.get('nums');
    if (prefill) input.value = prefill;
    paint();
  }
  const initialiseAll = () => document.querySelectorAll('[data-enetura-tracking]').forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
